<template>
	<div class="insideBody">
		<div class="learnSelection">
			<div class="top_ul">
				<div class="list clr" v-for="(item,index) in typedata" :key="index" :class="{'on':item.type == type}" @click="type = item.type">
					<img class="img fl" :src="require('../../assets/images/xqxh'+(item.type+2)+'.png')">
					<div class="tit">{{item.name}}</div>
				</div>
				<!-- <div class="list clr" :class="type == 2 ? 'on':''" @click="type = 2">
					<img class="img fl" src="../../assets/images/xqxh4.png">
					<div class="tit">升学版单词</div>
				</div>
				<div class="list clr" :class="list == 3 ? 'on':''" @click="list = 3">
					<img class="img fl" src="../../assets/images/xqxh5.png">
					<div class="tit">音标测试</div>
				</div>
				<div class="list clr" :class="list == 4 ? 'on':''" @click="list = 4">
					<img class="img fl" src="../../assets/images/xqxh6.png">
					<div class="tit">词根词缀</div>
				</div>
				<div class="list clr" :class="list == 5 ? 'on':''" @click="list = 5">
					<img class="img fl" src="../../assets/images/xqxh7.png">
					<div class="tit">口语测试</div>
				</div>
				<div class="list clr" :class="list == 6 ? 'on':''" @click="list = 6">
					<img class="img fl" src="../../assets/images/xqxh8.png">
					<div class="tit">同步课文</div>
				</div>
				<div class="list clr" :class="list == 7 ? 'on':''" @click="list = 7">
					<img class="img fl" src="../../assets/images/xqxh9.png">
					<div class="tit">智能阅读</div>
				</div>
				<div class="list clr" :class="list == 8 ? 'on':''" @click="list = 8">
					<img class="img fl" src="../../assets/images/xqxh10.png">
					<div class="tit">语法测试</div>
				</div> -->
			</div>
			
			<div class="tit_middle">
				<div class="tits">测试范围选择</div>
				<div class="testScope clr">
					<div class="choice fl">
						<el-radio v-model="scope" :label="1">分段</el-radio>
						<el-radio v-model="scope" :disabled="type == 2" :label="2">教材</el-radio>
						<el-radio v-model="scope" :disabled="true" :label="3">年级</el-radio>
					</div>
					<div class="select fr">
						<el-select v-model="bookid" @focus="setMinWidth" placeholder="请选择">
							<el-option :style="{'min-width':minWidth+'px'}" v-for="item in bookdata" :key="item.bookid" :label="item.bookname" :value="item.bookid"></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="tit_middle">
				<div class="tits">测试难度 / 题目数量</div>
				<div class="testScope clr">
					<div class="choice fl">
						<el-radio v-model="diff" :label="1">简单</el-radio>
						<el-radio v-model="diff" :label="2">中等</el-radio>
						<el-radio v-model="diff" :label="3">困难</el-radio>
					</div>
					<div class="select fr">
						<el-input-number :precision="0" v-model="count" controls-position="right" :min="40" :max="100"></el-input-number>
					</div>
				</div>
			</div>
			<div class="tit_middle">
				<div class="tits">题目类型</div>
				<div class="testScope clr">
					<div class="con_list">
						<div class="list" :class="wordtypeNum1 == 2 ? 'on':''" @click="wordtypeNum1 == 2 ? wordtypeNum1 = 0:wordtypeNum1 = 2">英译汉</div>
						<div class="list" :class="wordtypeNum2 == 4 ? 'on':''" @click="wordtypeNum2 == 4 ? wordtypeNum2 = 0:wordtypeNum2 = 4">汉译英</div>
						<div class="list" :class="wordtypeNum3 == 8 ? 'on':''" @click="wordtypeNum3 == 8 ? wordtypeNum3 = 0:wordtypeNum3 = 8">听写</div>
					</div>
				</div>
				<div class="bnt_list">
					<div class="btn" @click="routers">开始考试</div>
				</div>
			</div>
			
		</div>
	</div>
</template>
<script>
import {getbooks,getlearnrecord} from '@/api/control1'
export default {
  data(){
    return {
			height: null,
			type: 1,
			scope: 1,
			diff: 1,
			count: 40,
			bookid: 'XX01',
			bookdata:[
				{
					bookid: 'XX01',
					bookname: '小学'
				},{
					bookid: 'cz01',
					bookname: '初中'
				},{
					bookid: 'gz01',
					bookname: '高中'
				}
			],
			typedata:[
				{
					type: 1,
					name:'教材版单词'
				},
				{
					type: 2,
					name:'升学版单词'
				}
			],
			minWidth: null,
			wordtypeNum1: 2,
			wordtypeNum2: 4,
			wordtypeNum3: 0,
		};
	},
	created(){
	},
	filters: {
	  typeName(value,data){
	    for(var i=0;i<data.length;i++){
				if(value == data[i].type){
					return data[i].name;
				};
			};
	  },
		bookName(value,data){
		  for(var i=0;i<data.length;i++){
				if(value == data[i].bookid){
					return data[i].bookname;
				};
			};
		},
		diffName(value){
			if(value == 1){
				return '（简单）'
			}else if(value == 2){
				return '（中等）'
			}else if(value == 3){
				return '（困难）'
			}
		},
	},
	methods:{
		routers(){
			var that = this,typeName = that.$options.filters['typeName'],bookName = that.$options.filters['bookName'],diffName = that.$options.filters['diffName'],wordtype = that.wordtypeNum1+that.wordtypeNum2+that.wordtypeNum3,testname = typeName(that.type,that.typedata)+' - '+(that.scope == 1?'分段':'教材')+' - '+bookName(that.bookid,that.bookdata)+diffName(that.diff);
			if(wordtype == 0){
				that.$message.error('请选择题目类型');
				return false;
			};
			var routeData = this.$router.resolve({
			  path: '/examination?type='+that.type+'&scope='+that.scope+'&diff='+that.diff+'&wordtype='+wordtype+'&bookid='+that.bookid+'&count='+that.count+'&testname='+testname,
			});
			window.open(routeData.href, '_blank');
			// sssthis.$router.push({path:'/examination?type='+that.type+'&scope='+that.scope+'&diff='+that.diff+'&wordtype='+wordtype+'&bookid='+that.bookid+'&count='+that.count+'&testname='+testname})
			// getlearnrecord({
			// 	userid: that.utils.storageGet("userinfo").userid,
			// 	type: that.type,
			// 	scope: that.scope,
			// 	diff: that.diff,
			// 	wordtype: wordtype,
			// 	bookid: that.bookid,
			// 	testname: testname,
			// 	count: that.count
			// }).then(res => {
				
			// });
		},
		getbooks(){
			var that = this;
			getbooks({
				userid: that.utils.storageGet("userinfo").userid,
			}).then(res => {
				that.bookdata = res;
				that.bookid = res[0].bookid;
			});
		},
		setMinWidth(val){
			this.minWidth = val.srcElement.clientWidth;
		}
	},
	mounted(){
		var that = this;
		
	},
	components: {
		
	},
	watch: {
		type(val){
			var that = this;
			if(val == 2){
				that.scope = 1;
			};
		},
	  scope(val){
	    var that = this;
			if(val == 1){
				that.bookdata = [
					{
						bookid: 'XX01',
						bookname: '小学'
					},{
						bookid: 'cz01',
						bookname: '初中'
					},{
						bookid: 'gz01',
						bookname: '高中'
					}
				];
				that.bookid = 'XX01';
			}else if(val == 2){
				that.getbooks();
			};
	  }
	}
}
</script>
<style scoped>
	
</style>